export default __webpack_public_path__ + "cb989df1d869a49a32d04bf7cdbaf54a.png";